import actionTypes from 'constants/currentUserConstants';
import { change } from 'redux-form';
import { setupAuthorizationToken, clearAuthorizationToken } from 'lib/auth';
import { goToFinalStep } from 'actions/finalWizardActions';
import { goToNextSnapSellStep } from 'actions/snapSellWizardActions';
import Honeybadger from 'honeybadger-js';

export function fetchBasicUserDataFailure(error) {
  return (dispatch) => {
    dispatch({ type: actionTypes.FETCH_CURRENT_USER_FAILURE, payload: error });
    dispatch({ type: actionTypes.AUTHENTICATION_FAILURE });
    clearAuthorizationToken();
  };
}

export function fetchBasicUserDataSuccess(data) {
  return (dispatch) => {
    dispatch({ type: actionTypes.FETCH_CURRENT_USER_SUCCESS, payload: data });
    dispatch({ type: actionTypes.AUTHENTICATION_SUCCESS });
  };
}

export function fetchBasicUserData() {
  return (dispatch, getState, api) => {
    dispatch({ type: actionTypes.FETCH_CURRENT_USER_REQUEST });
    api.get('/users/me').then(
      response => dispatch(fetchBasicUserDataSuccess(response.data)),
      error => dispatch(fetchBasicUserDataFailure(error))
    );
  };
}

export function checkUserData() {
  return (dispatch, getState) => {
    dispatch({ type: actionTypes.CHECK_USER_DATA_STARTED });
    const currentToken = getState().currentUser.getIn(['data', 'token']);
    if (currentToken) {
      setupAuthorizationToken(currentToken);
      Honeybadger.setContext({
        user_email: getState().currentUser.getIn(['data', 'email'])
      });
      dispatch({ type: actionTypes.AUTHENTICATION_SUCCESS });
    } else {
      setupAuthorizationToken();
      dispatch(fetchBasicUserData());
    }
  };
}

const resolveFinalStep = state => {
  const { currentUser } = state;
  const emailChecked = currentUser.get('emailChecked');
  const passwordRequired = currentUser.get('passwordRequired');
  const userConfirmed = currentUser.get('confirmed');
  const confirmationResent = currentUser.get('resent');

  if (!emailChecked) return "email";
  if (!passwordRequired) return "account";
  if (!userConfirmed && !confirmationResent) return "confirm";
  return "password";
};

const isSnapSell = state => state.config.get('snap_sell_enabled', false);
const packageType = state => state.checkoutData && state.checkoutData.get('package_type', null);

export function checkEmail(email) {
  return (dispatch, getState, api) => {
    api.post('/users/check_email', { email }).then(
      (response) => {
        dispatch({ type: actionTypes.EMAIL_CHECKED, payload: response.data });
        dispatch(change('eventSubmission', 'id', null));

        const state = getState();
        const nextStep = resolveFinalStep(state);
        if (isSnapSell(state) && packageType(state) !== 'free' && nextStep === "account" ) {
          dispatch(goToNextSnapSellStep());
        } else {
          dispatch(goToFinalStep(nextStep));
        }
      }
    );
  };
}

export function resendConfirmation(email) {
  return (dispatch, getState, api) => {
    dispatch({ type: actionTypes.CONFIRMATION_REQUEST });

    api.post('/users/resend_confirmation', { email }).then(
      (response) => {
        dispatch({ type: actionTypes.CONFIRMATION_RESENT, payload: response.data });
        dispatch(goToFinalStep(resolveFinalStep(getState())));
      }
    );
  };
}

export function resetPassword(email) {
  return (dispatch, getState, api) => {
    dispatch({ type: actionTypes.CONFIRMATION_REQUEST });

    api.post('/users/reset_password', { email }).then(
      (response) => dispatch({ type: actionTypes.PASSWORD_RESET, payload: response.data })
    );
  };
}

export function signInUser(email, password, callback) {
  return (dispatch, getState, api) => {
    dispatch({ type: actionTypes.AUTHENTICATION_REQUEST });

    api.post('/auth_tokens', { email, password }).then(
      (response) => {
        setupAuthorizationToken(response.data.token);
        dispatch(fetchBasicUserDataSuccess(response.data));
        if (callback) { callback(); }
      },
      (error) => dispatch({ type: actionTypes.AUTHENTICATION_FAILURE, payload: error.response.data.error.details })
    );
  };
}



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/actions/currentUserActions.js